"use client";

import { SharedThreadModal } from "@/component/SharedThreadModal";
import { useRouter } from "@bprogress/next/app";

interface ThreadShareProps {
  threadId: string;
}

const HOME_ROUTE = "/";

export function ThreadShare(props: ThreadShareProps) {
  const { threadId } = props;
  const router = useRouter();

  const handleDialogClose = () => {
    router.push(HOME_ROUTE);
  };

  return (
    <SharedThreadModal
      open={true}
      onClose={handleDialogClose}
      threadId={threadId}
    />
  );
}
